module.exports = __webpack_public_path__ + "img/word_house_mask.d18ce27c.svg";